

export const GeneralInfoFields = [
    { key: 'id', label: 'Payment ID', type: 'text' },
    { key: 'name', label: 'Payment Terms', type: 'text' },
]



export const DaysFromTypes = [
    { value: 1, label: 'Transaction Date' },
    { value: 2, label: 'Discount Date' }
];

export const DaysFromTypeMap = {
    1: 'Transaction Date',
    2: 'Discount Date'
}

export const DueTypes = [
    { value: 1, label: 'None' },
    { value: 2, label: 'Net Days' },
    { value: 3, label: 'Date' },
    { value: 4, label: 'EOM' },
    { value: 5, label: 'Next Month' },
    { value: 6, label: 'Months' },
    { value: 7, label: 'Month/Day' },
    { value: 8, label: 'Annual' },
];

export const DueTypesMap = {
    1: 'None',
    2: 'Net Days',
    3: 'Date',
    4: 'EOM',
    5: 'Next Month',
    6: 'Months',
    7: 'Month/Day',
    8: 'Annual'
}

export const DiscountTypesMap = {
    1: 'None',
    2: 'Days',
    3: 'Date',
    4: 'EOM',
    5: 'Next Month',
    6: 'Months',
    7: 'Month/Day',
    8: 'Annual'
}
export const DiscountAppliedToTypesMap = {
    1: 'Precent',
    2: 'Amount'
}


export const DiscountTypes = [
    { value: 1, label: 'None' },
    { value: 2, label: 'Days' },
    { value: 3, label: 'Date' },
    { value: 4, label: 'EOM' },
    { value: 5, label: 'Next Month' },
    { value: 6, label: 'Months' },
    { value: 7, label: 'Month/Day' },
    { value: 8, label: 'Annual' },
];

export const DiscountAppliedToTypes = [
    { value: 1, label: 'Percent' },
    { value: 2, label: 'Amount' }
]


export const DueDateFields = [
    { key: 'daysFromType', label: 'Days From', options: DaysFromTypes, map: DaysFromTypeMap, type: 'select' },
    { key: 'daysFromDays', label: 'Add Days', type: 'number' },
    { key: 'dueType', label: 'Due', options: DueTypes, map: DueTypesMap, type: 'select' },
    { key: 'dueTypeDays', label: 'Add Days', type: 'number' },
]


export const DiscountFields = [
    { key: 'discount', label: 'Discount', options: DiscountTypes, map: DiscountTypesMap, type: 'select' },
    { key: 'discountDays', label: 'Add Days', type: 'number' },

    { key: 'discountType', label: 'Discount Type', options: DiscountAppliedToTypes, map: DiscountAppliedToTypesMap, type: 'select' },
    { key: 'discountValue', label: 'Discount Value', type: 'number' },


]

export const ApplyOnFields = [
    { key: 'salePurchase', label: 'Sale Purchase', type: 'checkbox' },
    { key: 'discountApplicable', label: 'Discount Applicable', type: 'checkbox' },
    { key: 'freight', label: 'Freight', type: 'checkbox' },
    { key: 'miscellaneous', label: 'Miscellaneous', type: 'checkbox' },
    { key: 'tax', label: 'Tax', type: 'checkbox' },
]

// all fields with types and maps (if any)
export const PaymentTermsFields = [

    { key: 'id', label: 'Payment ID', type: 'text' },
    { key: 'name', label: 'Payment Terms', type: 'text' },
    { key: 'daysFromType', label: 'Days From', map: DaysFromTypeMap, type: 'select', options: DaysFromTypes },
    { key: 'daysFromDays', label: 'Add Days', type: 'number' },
    { key: 'dueType', label: 'Due', map: DueTypesMap, type: 'select', options: DueTypes },
    { key: 'dueTypeDays', label: 'Add Days', type: 'number' },
    { key: 'discount', label: 'Discount', map: DiscountTypesMap, type: 'select', options: DiscountTypes },
    { key: 'discountDays', label: 'Add Days', type: 'number' },
    { key: 'discountType', label: 'Discount Type', map: DiscountAppliedToTypesMap, type: 'select', options: DiscountAppliedToTypes },
    { key: 'discountValue', label: 'Discount Value', type: 'number' },
    { key: 'salePurchase', label: 'Sale Purchase', type: 'checkbox' },
    { key: 'discountApplicable', label: 'Discount Applicable', type: 'checkbox' },
    { key: 'freight', label: 'Freight', type: 'checkbox' },
    { key: 'miscellaneous', label: 'Miscellaneous', type: 'checkbox' },
    { key: 'tax', label: 'Tax', type: 'checkbox' },

];


